/**
 * Three-point-ish studio lighting tuned for a matte wood product shot:
 * a soft key, a cooler fill from the opposite side, and a gentle rim to
 * separate the bat silhouette from the dark background.
 */
export function SceneLighting() {
  return (
    <>
      <ambientLight intensity={0.35} />
      <directionalLight
        position={[6, 8, 5]}
        intensity={1.15}
        color="#fff4e0"
        castShadow
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-left={-40}
        shadow-camera-right={40}
        shadow-camera-top={40}
        shadow-camera-bottom={-40}
      />
      <directionalLight position={[-6, 3, -4]} intensity={0.35} color="#5c93c4" />
      <directionalLight position={[0, 2, -8]} intensity={0.5} color="#ffffff" />
    </>
  );
}
